import BrandMark from '../components/common/BrandMark';

function PublicLayout({ children }) {
  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-950">
      <div className="pointer-events-none absolute left-1/2 top-[-18rem] size-[38rem] -translate-x-1/2 rounded-full bg-primary-500/10 blur-3xl" />
      <div className="relative mx-auto flex min-h-screen w-full max-w-7xl flex-col px-6 py-7 sm:px-10 lg:px-16">
        <header>
          <BrandMark />
        </header>
        <main className="flex flex-1 items-center py-16">{children}</main>
        <footer className="flex items-center justify-between border-t border-white/10 pt-6 text-xs text-slate-500">
          <span>Votum 2.0</span>
          <span>Frontend inicial</span>
        </footer>
      </div>
    </div>
  );
}

export default PublicLayout;
